export const SHADOWS = {
  TOP_LIGHT: `box-shadow: 0 -4px 8px rgba(104, 115, 130, 0.08);`,
  TOP: `box-shadow: 0 -4px 16px rgba(104, 115, 130, 0.16);`,
  TOP_DARK: `box-shadow: 0 -4px 24px rgba(104, 115, 130, 0.24);`,
  BOTTOM_LIGHT: `box-shadow: 0 4px 8px rgba(104, 115, 130, 0.08);`,
  BOTTOM: `box-shadow: 0 4px 16px rgba(104, 115, 130, 0.16);`,
  BOTTOM_DARK: `box-shadow: 0 4px 24px rgba(104, 115, 130, 0.24);`,
} as const;
